import React, { FC } from 'react';
import Lozenge from '@atlaskit/lozenge';

import { flexStart, spaceGapMinimum } from '@/styles';
import { localNumberFormat } from '@/utils';

import { ItemPeriodValueProps } from './types';
import { postfixStyles } from './styles';

const ItemPeriodValue: FC<ItemPeriodValueProps> = ({ appearance, count, period }) => (
  <span css={[flexStart, spaceGapMinimum]}>
    <Lozenge appearance={appearance ?? 'default'}>
      {count ? localNumberFormat(count) : 'not set'}
    </Lozenge>
    <img alt="/" src="/assets/slash.svg" />
    <span css={postfixStyles}>{period}</span>
  </span>
);

export default ItemPeriodValue;
